import { Progress } from "@/components/ui/progress";
import { goldenLabel, goldenPercent } from "./helpers";

const GoldenProgressBar = ({ labeled, target }: { labeled: number; target: number }) => (
  <div className="space-y-1">
    <p className="text-sm font-medium">{goldenLabel(labeled, target)}</p>
    <Progress value={goldenPercent(labeled, target)} className="h-2" />
  </div>
);

export default GoldenProgressBar;
